import { ChangeEvent } from "react";
import styled from "styled-components";
import { MAIN_THEME } from "styles/colors";

interface Props {
	value: string | number;
	onChange: (value: string | number) => void;
	placeholder?: string;
	leftContainer?: JSX.Element;
	rightContainer?: JSX.Element;
}

interface TextareaProps {
	leftContainer?: JSX.Element;
	rightContainer?: JSX.Element;
}

const Container = styled.div`
	min-height: 60px;
	width: 100%;
	background: ${MAIN_THEME.DARK_BG_TERTIARY};
	border: 1px solid ${MAIN_THEME.BORDER_COLOR};
	border-radius: 26px;
	display: flex;
	transition: all 0.3s ease;

	&:focus-within {
		border-color: ${MAIN_THEME.SECONDARY};
	}

`;

const TextareaComponent = styled.textarea<TextareaProps>`
	min-height: 100px;
	width: 100%;
	background: transparent;
	border-radius: 55px;
	border: none;
	color: ${MAIN_THEME.TEXT_PRIMARY};
	font-size: 16px;
	padding-left: ${(props) => (props.leftContainer ? 0 : "24px")};
	padding-right: ${(props) => (props.rightContainer ? 0 : "24px")};
	padding-top: 15px;
	padding-bottom: 10px;
	outline: none;
	resize: none;
	font-family: inherit;

	::placeholder,
	::-webkit-input-placeholder {
		color: ${MAIN_THEME.TEXT_TERTIARY};
	}
	:-ms-input-placeholder {
		color: ${MAIN_THEME.TEXT_TERTIARY};
	}

	@media (max-width: 768px) {
		font-size: 14px;
		min-height: 80px;
	}
`;

const Textarea = (props: Props): JSX.Element => {
	const { value, onChange, placeholder, leftContainer, rightContainer } = props;

	const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
		const newValue = event.target.value;

		onChange(newValue);
	};

	return (
		<Container>
			{leftContainer}
			<TextareaComponent
				value={value}
				onChange={handleChange}
				placeholder={placeholder}
				rightContainer={rightContainer}
				leftContainer={leftContainer}
			/>
			{rightContainer}
		</Container>
	);
};

export default Textarea;
